import { isFeatureEnabled } from 'owa-feature-flags';

const isNewThrottlingEnabled = (): boolean => {
    return isFeatureEnabled('rp-attachmentThumbnailNewThrottling');
};

export default isNewThrottlingEnabled;
